import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);
  const [showManage, setShowManage] = useState(false);
  const [preferences, setPreferences] = useState({ essential: true, analytics: false, marketing: false });

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) setShow(true);
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie-consent', JSON.stringify({ essential: true, analytics: true, marketing: true, timestamp: new Date().toISOString() }));
    setShow(false);
  };

  const rejectAll = () => {
    localStorage.setItem('cookie-consent', JSON.stringify({ essential: true, analytics: false, marketing: false, timestamp: new Date().toISOString() }));
    setShow(false);
  };

  const savePreferences = () => {
    localStorage.setItem('cookie-consent', JSON.stringify({ ...preferences, timestamp: new Date().toISOString() }));
    setShow(false);
    setShowManage(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4">
      <div className="max-w-4xl mx-auto glass rounded-xl p-6 border border-white/10 shadow-2xl">
        {!showManage ? (
          <>
            <div className="flex items-start gap-4 mb-4">
              <div className="flex-1">
                <h3 className="font-semibold text-lg mb-2">Cookie Preferences</h3>
                <p className="text-sm text-muted-foreground">
                  We use cookies to enhance your experience, analyse site traffic, and for marketing purposes. 
                  By clicking "Accept All", you consent to our use of cookies. 
                  <Link to="/privacy" className="text-violet-500 hover:underline ml-1">Privacy Policy</Link>
                </p>
              </div>
            </div>
            <div className="flex flex-wrap gap-3">
              <Button onClick={acceptAll} className="bg-violet-600 hover:bg-violet-700 rounded-full">Accept All</Button>
              <Button onClick={rejectAll} variant="outline" className="rounded-full">Reject All</Button>
              <Button onClick={() => setShowManage(true)} variant="ghost" className="rounded-full">Manage Preferences</Button>
            </div>
          </>
        ) : (
          <>
            <h3 className="font-semibold text-lg mb-4">Manage Cookie Preferences</h3>
            <div className="space-y-4 mb-6">
              <div className="flex items-center justify-between p-3 rounded-lg bg-white/5">
                <div><p className="font-medium">Essential Cookies</p><p className="text-sm text-muted-foreground">Required for the website to function. Cannot be disabled.</p></div>
                <input type="checkbox" checked={true} disabled className="w-5 h-5 accent-violet-500" />
              </div>
              <div className="flex items-center justify-between p-3 rounded-lg bg-white/5">
                <div><p className="font-medium">Analytics Cookies</p><p className="text-sm text-muted-foreground">Help us understand how visitors interact with our website.</p></div>
                <input type="checkbox" checked={preferences.analytics} onChange={(e) => setPreferences({...preferences, analytics: e.target.checked})} className="w-5 h-5 accent-violet-500" />
              </div>
              <div className="flex items-center justify-between p-3 rounded-lg bg-white/5">
                <div><p className="font-medium">Marketing Cookies</p><p className="text-sm text-muted-foreground">Used to deliver relevant advertisements and track campaigns.</p></div>
                <input type="checkbox" checked={preferences.marketing} onChange={(e) => setPreferences({...preferences, marketing: e.target.checked})} className="w-5 h-5 accent-violet-500" />
              </div>
            </div>
            <div className="flex gap-3">
              <Button onClick={savePreferences} className="bg-violet-600 hover:bg-violet-700 rounded-full">Save Preferences</Button>
              <Button onClick={() => setShowManage(false)} variant="ghost" className="rounded-full">Back</Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
